export const DEFAULT_PAGE_TITLE = 'Supplier Invoices';
